<template>
  <div class="container wrapper">
    <div class="success-card" v-if="product">
      <div class="card-title">
        <svg
          class="svg"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="#13bf80"
            transform="translate(-134.34 -119.68)"
            d="M146.34,119.68a12,12,0,1,0,12,12A12,12,0,0,0,146.34,119.68Zm6.883,8.887-7.762,7.762a1.085,1.085,0,0,1-1.536,0l-4.467-4.47a1.086,1.086,0,1,1,1.535-1.535l3.7,3.7,6.994-6.993a1.086,1.086,0,0,1,1.536,1.536Zm0,0"
          />
        </svg>
        <span>支付成功！</span>
      </div>
      <div class="goods-infor">
        <div class="infor">
          <div class="name">
            <span class="label">{{ product.type_name }}</span>
            <p class="text">{{ product.name }}</p>
          </div>
          <div class="describe">
            <p class="text">￥{{ product.amount }}</p>
            <p class="text">数量：{{ product.count }}</p>
          </div>
        </div>
      </div>
      <!-- 课程跳转网页详情 -->
      <!-- <div v-if="product.type == 'course'">
                <van-button round type="primary" class="open-button" @click="clickButton">开始学习</van-button>
            </div> -->
      <!-- 其他唤醒app -->
      <!-- <div v-else>

            </div> -->
      <OpenApp :unitKey="openAppOptions.unitKey" :options="openAppOptions.param">
        <van-button round type="primary" class="open-button">打开APP查看</van-button>
      </OpenApp>
      <!-- <div class="customer">如果您有任何疑问，请<a class="text" href="#" target="_blank">联系客服</a> </div> -->
    </div>
  </div>
</template>
<script>
import { getPayProducts } from '@/utils/cookies'
import OpenApp from '@/components/OpenApp.vue'
export default {
  mixins: [],
  data() {
    return {
      product: null,
    }
  },
  computed: {
    openAppOptions() {
      const goodsType = this.product.type
      if (goodsType === 'course') {
        return { unitKey: 'CourseDetail', param: { no: this.product.item_no } }
      }
      return {
        unitKey: 'Order',
        param: {},
        appParam: {
          unitKey: 'Home',
        },
      }
    },
  },
  mounted() {
    const products = getPayProducts()
    this.product = products[0]
    if (products.length === 0) {
      this.$router.replace({ path: this.$route.query.beforeRouteFullPath })
    }
    document.getElementsByTagName('title')[0].innerText = '支付结果'
  },
  methods: {
    clickButton() {
      // 课程回调课程详情
      // this.$router.replace({ path: this.$route.query.beforeRouteFullPath });
      history.back()
    },
  },
  components: { OpenApp },
}
</script>
<style lang="scss" scoped>
.wrapper {
  background-color: #fff;
}

.success-card {
  padding-top: 1.6rem;

  .card-title {
    @include flex_center;
    font-size: 0.53rem;
    line-height: 1.2;
    font-weight: 500;
    color: #22242e;
    margin-bottom: 1rem;

    .svg {
      margin-right: 0.27rem;

      path {
        fill: var(--main-color);
      }
    }
  }

  .goods-infor {
    background: rgba($color: #f7f8fa, $alpha: 0.6);
    border-radius: 0.21rem;
    padding: 0.53rem 0.43rem;
    margin-bottom: 1.28rem;

    .name {
      display: flex;
      font-size: 0.35rem;
      line-height: 0.53rem;
      color: #22242e;
      opacity: 0.8;
      margin-bottom: 0.27rem;

      .label {
        @include flex_center;
        height: 0.4rem;
        background: rgba($color: #8f97a8, $alpha: 0.5);
        border-radius: 0.07rem;
        font-size: 0.27rem;
        color: #ffffff;
        padding: 0 0.1rem;
        margin-right: 0.2rem;
        line-height: 0;
        transform: translateY(0.05rem);
      }

      .text {
        flex: 1;
      }
    }

    .describe {
      display: flex;

      & + .describe {
        margin-top: 0.16rem;
      }

      .text {
        font-size: 0.32rem;
        font-weight: 400;
        color: #919499;
        opacity: 0.8;
        width: 1.4rem;
      }
    }
  }

  .open-button {
    @include margin_center;
    display: block;
    width: 7.47rem;
    font-size: 0.4rem;
    height: 1.17rem;
  }

  .customer {
    position: fixed;
    bottom: 0.85rem;
    left: 0;
    width: 100%;
    font-size: 0.32rem;
    font-weight: 400;
    color: #919499;
    text-align: center;

    .text {
      color: #448aff;
    }
  }
}
</style>
